<app-loader [isLoading]="fcLoading"></app-loader>
<div class="containerManageDialogue">
  <div class="topHead d-flex justify-content-between">
    <div class="d-flex justify-content-between">
      <span>Review updated data ({{ this.memberKey }})</span>
      <div class="close-button" mat-button mat-dialog-close>
        <mat-icon class="close-icon">close</mat-icon>
      </div>
    </div>
    <div class="updated-div">Updated By- {{this.rowData.updatedBy}}</div>
  </div>
  <div class="dialog-body">
    <form [formGroup]="manageruserForm">
      <div class="persoInfo">
        <div class="rowHead mb-3">
          <span>Personal information:</span>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Member name</label>
              <input type="text" readonly formControlName="fullName" class="search-input dp-input-control"
                placeholder="Member name" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Guardian Name</label>
              <input type="text" readonly formControlName="guardianName" class="search-input dp-input-control"
                placeholder="Father/Husband name" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Ritwik Name</label>
              <input type="text" readonly formControlName="ritwikName" class="search-input dp-input-control"
                placeholder="Ritwik name" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Suggested Member Name</label>
              <input type="text" [readonly]="!su_review_data" formControlName="suggestedMemberName"
                class="search-input dp-input-control" placeholder="Suggested member" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Suggested Guardian Name</label>
              <input type="text" [readonly]="!su_review_data" formControlName="suggestedGuardianName"
                class="search-input dp-input-control" placeholder="Suggested guardian" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Suggested Ritwik’s Name</label>
              <input type="text" formControlName="suggestedRitwikName" class="search-input dp-input-control"
                placeholder="Enter first name" readonly />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Philanthropy Name</label>
              <input type="text" readonly formControlName="philMemberName" class="search-input dp-input-control"
                placeholder="Philanthropy name" />
            </div>
          </div>
          @if(rowData.suggestedRitwikName && !rowData.suggestedRitwikCode && this.su_review_data){
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Suggested Ritwik's Code</label>
              <input type="text" formControlName="ritwikCode" class="search-input dp-input-control"
                placeholder="Ritwik Code" [matAutocomplete]="auto" />
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                @for (ritwik of filteredRitwikList ; track ritwik) {
                <mat-option (onSelectionChange)="automatedDropVal(ritwik)" [value]="ritwik.dwd_worker_name">
                  <div class="inp-loc-wrap">
                    <span>{{
                      ritwik.dwd_worker_name
                      }}</span>
                    @if((ritwik.dwd_district_name !==''&& ritwik.dwd_district_name!==null &&
                    ritwik.dwd_district_name)&&
                    (ritwik.dwd_state_name !==''&& ritwik.dwd_state_name!==null && ritwik.dwd_state_name)){
                    <span class="loc-text"> {{ritwik.dwd_state_name}}, {{ ritwik.dwd_district_name }}</span>
                    }
                  </div>
                </mat-option>
                }
              </mat-autocomplete>
              @if(!suggestedRitwikCode && this.su_review_data)
              {
              <span class="error-text">Type Ritwik Name and Select from Dropdown</span>
              }
            </div>
          </div>
          }
        </div>
      </div>
      <div class="persoInfo">
        <div class="rowHead mb-3">
          <span>Initiation information:</span>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Diksharthi status</label>
              <input type="text" readonly formControlName="memStatus" class="search-input dp-input-control"
                placeholder="Diksharthi status" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Family code</label>
              @if(rowData.memberFamilyCode!==null){
              <div class="d-flex align-items-center" style="border: 1px solid var(--bg-overlay)">
                <input type="text" readonly formControlName="memberFamilyCode" class="search-input dp-input-control"
                  placeholder="Family code" style="border: none" /><img src="../../../assets/images/shield-inactive.svg"
                  class="img-fc" (click)="onFcClick()" />
              </div>
              }@else{
              <input type="text" readonly formControlName="memberFamilyCode" class="search-input dp-input-control"
                placeholder="Family code" />
              }
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Last istavrity</label>
              <input type="text" readonly formControlName="lastIVDate" class="search-input dp-input-control"
                placeholder="-" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="inpSec">
              <label class="inpLabel" for="">Email address</label>
              <input type="text" readonly formControlName="email" class="search-input dp-input-control"
                placeholder="Email address" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="inpSec">
              <label class="inpLabel" for="">Contact number</label>
              <input type="text" readonly formControlName="contactNumber" class="search-input dp-input-control"
                placeholder="Contact number" />
            </div>
          </div>
        </div>
      </div>
       <div class="persoInfo">
        <div class="rowHead mb-3">
          <span>Old address:</span>
        </div>
        <div class="row">
          <!-- <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Home No/street</label>
              <input type="text" [readonly]="!su_review_data" formControlName="presentAddressLine1"
                class="search-input dp-input-control" placeholder="Home No/street" />
            </div>
          </div> -->
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Address</label>
              <input type="text" readonly formControlName="oldAddress" class="search-input dp-input-control"
                placeholder="PIN code" />
            </div>
          </div>
         <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">State</label>
              <input type="text" readonly formControlName="oldState" class="search-input dp-input-control"
                placeholder="State" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">District</label>
              <input type="text" readonly formControlName="oldDistrict" class="search-input dp-input-control"
                placeholder="District" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Post Office</label>
              <input type="text" readonly formControlName="oldPO" class="search-input dp-input-control"
                placeholder="Post" />
            </div>
          </div>
          <!-- <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Landmark</label>
              <input type="text" [readonly]="!su_review_data" formControlName="presentAddressLine2"
                class="search-input dp-input-control" placeholder="Landmark" />
            </div>
          </div> -->
      </div>
      </div>
      <div class="persoInfo">
        <div class="rowHead mb-3">
          <span>Permanent address:</span>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Home No/street</label>
              <input type="text" [readonly]="!su_review_data" formControlName="permanentAddressLine1"
                class="search-input dp-input-control" placeholder="Home No/street" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">PIN code</label>
              <input type="text" readonly formControlName="permanentPin" class="search-input dp-input-control"
                placeholder="PIN code" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Post Office</label>
              <input type="text" readonly formControlName="permanentPO" class="search-input dp-input-control"
                placeholder="Post" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">District</label>
              <input type="text" readonly formControlName="permanentDistrict" class="search-input dp-input-control"
                placeholder="District" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">State</label>
              <input type="text" readonly formControlName="permanentState" class="search-input dp-input-control"
                placeholder="State" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Landmark</label>
              <input type="text" [readonly]="!su_review_data" formControlName="permanentAddressLine2"
                class="search-input dp-input-control" placeholder="Landmark" />
            </div>
          </div>
        </div>
      </div>
      <div class="persoInfo">
        <div class="rowHead mb-3">
          <span>Present address:</span>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Home No/street</label>
              <input type="text" [readonly]="!su_review_data" formControlName="presentAddressLine1"
                class="search-input dp-input-control" placeholder="Home No/street" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">PIN code</label>
              <input type="text" readonly formControlName="presentPin" class="search-input dp-input-control"
                placeholder="PIN code" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Post Office</label>
              <input type="text" readonly formControlName="presentPO" class="search-input dp-input-control"
                placeholder="Post" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">District</label>
              <input type="text" readonly formControlName="presentDistrict" class="search-input dp-input-control"
                placeholder="District" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">State</label>
              <input type="text" readonly formControlName="presentState" class="search-input dp-input-control"
                placeholder="State" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="inpSec">
              <label class="inpLabel" for="">Landmark</label>
              <input type="text" [readonly]="!su_review_data" formControlName="presentAddressLine2"
                class="search-input dp-input-control" placeholder="Landmark" />
            </div>
          </div>
        </div>
      </div>
     
      <div class="persoInfo">
        <div class="rowHead mb-3">
          <span>Summary:</span>
        </div>
        <div class="row">
          <div class="comments-div">
            <div class="inpSec">
              <label class="inpLabel" for="">Comment</label>
              <input type="text" readonly formControlName="comments" class="search-input dp-input-control"
                placeholder="comments" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="actionButton">
    @if (can_mark_check && checkRecordStatus.includes(rowData.recordStatus)) {
    <div (click)="checkDatum()" class="dp-secondary-btn actBtn">
      <!-- <div class="cross"></div> -->
      <span>Check</span>
    </div>
    }
    @if (can_mark_reset && resetRecordStatus.includes(rowData.recordStatus)) {
    <div (click)="resetDatum()" class="dp-secondary-btn actBtn">
      <!-- <div class="cross"></div> -->
      <span>Reset Data</span>
    </div>
    }
    @if (can_mark_reject && rejectRecordStatus.includes(rowData.recordStatus)) {
    <div (click)="rejectionDatum()" class="dp-destructive-btn actBtn">
      <!-- <div class="cross"></div> -->
      <span>Reject</span>
    </div>
    }
    @if (can_mark_approve && acceptRecordStatus.includes(rowData.recordStatus)) {
    <div class="dp-primary-btn actBtn" (click)="acceptDialogue()">
      <!-- <div class="tick"></div> -->
      <span>Accept</span>
    </div>
    }
  </div>
</div>